import { useNavigate } from 'react-router'

import useAppDispatch from '@/hooks/useAppDispatch'
import { useIsRoute } from '@/hooks/useIsRoute'
import { ROUTES } from '@/lib/routes'
import {
  REFERRAL_METHOD,
  reset,
  setReferralMethod,
} from '@/redux/slices/webReferral'

export function useReferToAdviserEmail() {
  const dispatch = useAppDispatch()
  const isRoute = useIsRoute()
  const navigate = useNavigate()

  return function () {
    if (isRoute(ROUTES._referClient)) {
      dispatch(reset())
      dispatch(setReferralMethod(REFERRAL_METHOD.newAdviser))

      return
    }

    navigate(
      ROUTES.referClient({
        searchParams: { isReferringToAdviserEmail: 'true' },
      }),
    )
  }
}
